// [ear-chat] 全局耳朵：不在通话也能听。开一路麦，原始音频递给壳里的 EarListener（和通话页同一只耳朵），
// 认出来的标签（喘息、叹气、呻吟……）POST /api/ear 给后端，他在文字聊天里也看得到；
// 突然有动静而你没在跟他说话，后端会把他叫醒。通话页有自己那路麦，进通话时这里让路，出来再接上。
var st = { on: false, paused: false, stream: null, ctx: null, last: '', seen: {}, subs: [] };

var native = function() { return !!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.nativeAction); };
var postNative = function(obj) { try { window.webkit.messageHandlers.nativeAction.postMessage(obj); } catch(e) {} };
var emit = function(ev) { st.subs.slice().forEach(function(f) { try { f(ev); } catch(e) {} }); };

export var earNativeOK = native;
export function earGet() { return { on: st.on, paused: st.paused, last: st.last }; }
export function earSubscribe(fn) { st.subs.push(fn); return function() { st.subs = st.subs.filter(function(f) { return f !== fn; }); }; }

function installHandler() {
  window.aizhiEar = function(t) {
    if (!t || !t.cn || !st.on || st.paused) return;
    var now = Date.now(), key = t.tag || t.cn;
    if (st.seen[key] && now - st.seen[key] < 8000) return;   // 同种 8 秒一次
    st.seen[key] = now;
    st.last = t.cn;
    emit({ type: 'tag', tag: key, cn: t.cn });
    setTimeout(function() { if (st.last === t.cn) { st.last = ''; emit({ type: 'tag', tag: '', cn: '' }); } }, 3500);
    fetch('/api/ear', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ tag: key, cn: t.cn }) }).catch(function() {});
  };
}

async function openMic() {
  if (st.stream) return;
  try {
    var stream = await navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: false, autoGainControl: false } });
    st.stream = stream;
    var AC = window.AudioContext || window.webkitAudioContext;
    var ctx = new AC(); st.ctx = ctx;
    var src = ctx.createMediaStreamSource(stream);
    var proc = ctx.createScriptProcessor(4096, 1, 1);
    var ratio = ctx.sampleRate / 16000, acc = [], accLen = 0;
    proc.onaudioprocess = function(e) {
      if (!st.on || st.paused) return;
      var inp = e.inputBuffer.getChannelData(0);
      var outN = Math.floor(inp.length / ratio), out = new Int16Array(outN);
      for (var i = 0; i < outN; i++) { var p = i * ratio, j = Math.floor(p), v = (inp[j] + (inp[j + 1] || inp[j])) * 0.5; out[i] = Math.max(-32768, Math.min(32767, Math.round(v * 32767))); }
      acc.push(out); accLen += outN;
      if (accLen >= 8000) {
        var all = new Int16Array(accLen), o = 0; acc.forEach(function(a) { all.set(a, o); o += a.length; }); acc = []; accLen = 0;
        var bytes = new Uint8Array(all.buffer), bin = '';
        for (var k = 0; k < bytes.length; k += 8192) bin += String.fromCharCode.apply(null, bytes.subarray(k, k + 8192));
        postNative({ action: 'ear_pcm', b64: btoa(bin) });
      }
    };
    src.connect(proc); proc.connect(ctx.destination);
    postNative({ action: 'ear_state', enabled: true, talking: false });
    installHandler();
    emit({ type: 'state', on: true });
  } catch(e) { console.log('[ear-chat] 开麦失败', e); st.on = false; emit({ type: 'state', on: false }); }
}
function closeMic() {
  if (native()) postNative({ action: 'ear_state', enabled: false });
  if (st.ctx) { try { st.ctx.close(); } catch(e) {} st.ctx = null; }
  if (st.stream) { st.stream.getTracks().forEach(function(t) { t.stop(); }); st.stream = null; }
}

export function earSetOn(on) {
  st.on = !!on;
  try { localStorage.setItem('ear_chat_enabled', st.on ? 'true' : 'false'); } catch(e) {}
  if (!native()) return;
  if (st.on) { if (!st.paused) openMic(); }
  else { closeMic(); st.last = ''; emit({ type: 'state', on: false }); fetch('/api/ear', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ off: true }) }).catch(function() {}); }
}
// 通话页进来：把麦让给它；出去：接回来
export function earPause() { st.paused = true; closeMic(); }
export function earResume() { st.paused = false; if (st.on && native()) openMic(); }

if (typeof window !== 'undefined') {
  try {
    if (localStorage.getItem('ear_chat_enabled') === 'true') {
      var tries = 0, t = setInterval(function() { tries++; if (native()) { clearInterval(t); earSetOn(true); } else if (tries > 20) clearInterval(t); }, 500);
    }
  } catch(e) {}
}
